import _get from 'lodash/get'
import { compose, withHandlers } from 'recompose'
import { connect } from 'react-redux'
import { EMPTY_OBJECT } from 'constants/frozenObjects'
import { withLocalization } from 'hocs/localization'
import { hiddenUnmountedModal } from 'hocs/hiddenUnmountedModal'
import { getEPSONContacts } from 'redux-app/selectors/contacts'
import { closeModal } from 'redux-app/modules/modals'
import { MODAL_FORBIDDEN_CHANGING_PLAN } from './constants'
import ForbiddenChangingPlanModal from './ForbiddenChangingPlanModal'

export default compose(
  hiddenUnmountedModal(MODAL_FORBIDDEN_CHANGING_PLAN),
  withLocalization('profile.manageAccount'),
  connect(
    state => {
      const contacts = getEPSONContacts(state) || EMPTY_OBJECT
      return {
        phoneNumber: _get(contacts, 'general.phoneNumber', ''),
      }
    },
    {
      closeModal,
    },
  ),
  withHandlers({
    onClose: ({ closeModal }) => () => closeModal({ name: MODAL_FORBIDDEN_CHANGING_PLAN }),
  }),
)(ForbiddenChangingPlanModal)
